import axiosInstance from "../../../api/axiosInstance";

export default {
  namespaced: true,
  state: {
    students: [],
    archivedStudents: [],
    student: {},
    studentActivityHistory: [],
    totalPlayTime: 0,
  },
  actions: {
    async sendGameSessionCommand(
      { commit },
      { student_id, command, session_token }
    ) {
      const response = await axiosInstance.post(
        `/students/${student_id}/game_session_command`,
        {
          command,
          session_token,
        }
      );
      return response.data;
    },
    async loadStudents({ commit }, { class_room_id, archived }) {
      const response = await axiosInstance.get("/students", {
        params: { class_room_id, archived },
      });
      if (archived) {
        commit("setArchivedStudents", response.data);
      } else {
        commit("setStudents", response.data);
      }
    },
    async loadStudent({ commit }, id) {
      try {
        const response = await axiosInstance.get(`/students/${id}`);
        commit("setStudent", response.data);
        return response;
      } catch (error) {
        return error.response;
      }
    },
    async loadStudentActivityHistory({ commit }, { id, start_date, end_date }) {
      const response = await axiosInstance.get(
        `/students/${id}/activity_history`,
        {
          params: { start_date, end_date },
        }
      );
      commit("setStudentActivityHistory", response.data.activity_history);
      commit("setTotalPlayTime", response.data.total_play_time);
    },
    async createNote(
      { commit, state },
      { content, title, noteType, studentId, noteId }
    ) {
      const response = await axiosInstance.post(
        `/students/${studentId}/notes`,
        {
          content: content,
          title: title,
          note_type: noteType,
          note_id: noteId,
        }
      );
      commit("setStudent", { ...state.student, notes: response.data });
      return response.data;
    },
    async createStudents({}, { names, class_room_id }) {
      await axiosInstance.post(`/students`, {
        names,
        class_room_id,
      });
    },
    async createStudentTransfer({ commit }, { student_id, classroom_key, classroom_id }) {
      await axiosInstance.post(`/students/${student_id}/transfer`, {
        classroom_key,
        classroom_id,
      });
    },
    async completeStudentTransfer(
      { commit },
      { student_id, transfer_id, accepted }
    ) {
      await axiosInstance.post(`/students/${student_id}/complete_transfer`, {
        transfer_id,
        accepted,
      });
    },
    async archiveStudent({}, { student_id }) {
      await axiosInstance.post(`/students/${student_id}/archive`);
    },
    async restoreStudent({}, { student_id, classroom_id }) {
      await axiosInstance.post(`/students/${student_id}/restore`, {
        classroom_id,
      });
    },
    async deleteStudent({}, student_id) {
      await axiosInstance.delete(`/students/${student_id}`);
    },
    async updateStudent({}, student) {
      await axiosInstance.put(`/students/${student.id}`, student);
    },
    async setOnlineStatus({ commit, state }, { student_id, online_status }) {
      const student = state.students.find(
        (student) => student.id === student_id
      );
      const live = online_status === "online";
      student.live = live;
      if (state.student.id === student_id) {
        state.student.live = live;
      }
    },
  },
  mutations: {
    setStudents(state, students) {
      state.students = students;
    },
    setArchivedStudents(state, students) {
      state.archivedStudents = students;
    },
    setStudent(state, student) {
      state.student = student;
    },
    removeNote(state, { noteType, date, noteId }) {
      state.student.notes[noteType][date] = state.student.notes[noteType][
        date
      ].filter((note) => note.id !== noteId);
    },
    setStudentActivityHistory(state, studentActivityHistory) {
      state.studentActivityHistory = studentActivityHistory;
    },
    setTotalPlayTime(state, totalPlayTime) {
      state.totalPlayTime = totalPlayTime;
    },
  },
  getters: {
    students: (state) => state.students,
    student: (state) => state.student,
    studentActivityHistory: (state) => state.studentActivityHistory,
    archivedStudents: (state) => state.archivedStudents,
    totalPlayTime: (state) => state.totalPlayTime,
  },
};
